import { getInputModality } from '#pplx/frontend/aether/getInputModality.js';
import { useCallback, useRef } from 'react';
/**
 * Suppresses focus-triggered open events when the user is in mouse modality.
 *
 * This prevents tooltips/overlays from appearing when focus is programmatically
 * restored (e.g., after a modal or dialog closes) while preserving the behavior
 * for keyboard users who rely on focus-triggered tooltips for accessibility.
 */
export function useModalityAwareOnOpenChange({ onOpenChange, }) {
    const isPointerOverTriggerRef = useRef(false);
    const handlePointerEnter = useCallback(() => {
        isPointerOverTriggerRef.current = true;
    }, []);
    const handlePointerLeave = useCallback(() => {
        isPointerOverTriggerRef.current = false;
    }, []);
    const handleOpenChange = useCallback((newOpen) => {
        if (newOpen && !isPointerOverTriggerRef.current && getInputModality() === 'mouse') {
            return;
        }
        onOpenChange(newOpen);
    }, [onOpenChange]);
    return {
        onPointerEnter: handlePointerEnter,
        onPointerLeave: handlePointerLeave,
        onOpenChange: handleOpenChange,
    };
}
//# sourceMappingURL=useModalityAwareOnOpenChange.js.map